module.exports = __webpack_public_path__ + "img/0Q3A0072_L_Foamcore_MockedUp.e84850bc.jpg";